/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icn24_arrow_up': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M12.293 10.239a.45.45 0 00-.586 0l-6.219 5.33a.75.75 0 11-.976-1.138L10.73 9.1a1.95 1.95 0 012.538 0l6.22 5.33a.75.75 0 11-.977 1.14l-6.22-5.331z" _fill="#000"/>'
  }
})
